import React, { useEffect } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { Outlet } from 'react-router-dom';
import { AppProvider } from '@toolpad/core/react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import CollectionsIcon from '@mui/icons-material/Collections';
import WorkIcon from '@mui/icons-material/Work';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import useAppStore from "./appStore";

const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'posts',
    title: 'Posts',
    icon: <WorkIcon />,
  },
  {
    segment: 'snapshots',
    title: 'Snapshots',
    icon: <CollectionsIcon />,
  },
  {
    segment: 'orders',
    title: 'Orders',
    icon: <LocalMallIcon />,
  },
];


export default function App() {
  const navigate = useNavigate();
  const { userEmail, userName, updateToken, updateUserName, updateUserEmail, token } = useAppStore();

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (token) {
        setSession({
          user: {
            name: userName,
            email: userEmail,
            image: <AccountCircleIcon />,
          },
        });
      }
      else {
        setSession(null);
        updateToken('');
        updateUserEmail('');
        updateUserName('');
        navigate('/auth/login');
      }
    });

    // Clean up subscription
    return () => unsubscribe();
  }, []);

  const [session, setSession] = React.useState({
    user: {
      name: userName,
      email: userEmail,
      image: <AccountCircleIcon />,
    },
  });

  const authentication = React.useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: userName,
            email: userEmail,
            image: <AccountCircleIcon />,
          },
        });
      },
      signOut: async () => {
        await auth.signOut();
        setSession(null);
        updateToken('');
        updateUserEmail('');
        updateUserName('');
        navigate('/auth/login');
      },
    };
  }, []);

  return (
    <AppProvider
      session={session}
      authentication={authentication}
      navigation={NAVIGATION}
      // theme={demoTheme}
      branding={{
        logo: <img src="https://codingmstr.com/img/logo-white.png" alt="MUI logo" />,
        title: 'CodingMSTR',
      }}
    >
      <Outlet />
    </AppProvider>
  );
}